import { fetchData } from '../actions/gridDataTable';
import { actions as pagerActions } from 'rp-react-pagination';
import { queryUrl } from './urlBuilder';
import { updateCatalogueLotsFound } from '../actions/catalogue';

/**
 * Performs initial update of table from given URL
 *
 * @param {undefined|string} [url] fetch URL
 * @param {undefined|string} [stateKey] table state key
 * @param {bool} [skipInitialData] If true, initial data never will be used
 * @returns {Function} Dispatch prop
 */

export const initialTableUpdate = (url, stateKey, skipInitialData) =>
    props => {
        if (!skipInitialData && window.initialData) {
            let initialData = window.initialData;
            if (stateKey) {
                initialData = initialData[stateKey];
                delete window.initialData[stateKey];
            } else {
                delete window.initialData;
            }
            return props.update(url, initialData);
        }

        return props.update(url);
    };

/**
 * Update pager and total lots
 * Used for catalogue tables with pagers
 *
 * @param {string} stateKey Reducer state key
 * @param {number} pagerLength Pager length parameter
 * @returns {Function} Dispatchable action
 */
export const updatePagerAndLotsFound = (stateKey, pagerLength) =>
    rawData =>
        dispatchFunc => {
            const data = Object.assign({}, {
                pagination: {
                    offset: 0,
                    totalItems: 0,
                    totalPages: 0,
                    currentPage: 0
                }
            }, rawData);

            return dispatchFunc([
                pagerActions.pagerUpdate(
                    stateKey,
                    data.pagination,
                    pagerLength
                ),
                updateCatalogueLotsFound(data.pagination.totalItems)
            ]);
        };

/**
 * Update table after page was changed
 *
 * @param {Function} dispatch Redux dispatch function
 * @param {string} stateKey Reducer state key
 * @param {string} defaultUrl Default fetch URL of table
 * @param {Function} afterUpdate After update actions
 * @returns {Function} Dispatch prop
 */
export const updateTableOnPageChange = (dispatch, stateKey, defaultUrl, afterUpdate) =>
    page =>
        dispatch(
            (dispatchFunc, getState) => {
                const url = getState()[stateKey].gridDataTable.url || defaultUrl;
                return dispatch(fetchData(stateKey, queryUrl(url, { page }), afterUpdate));
            }
        );

/**
 * Update table after filter applying
 *
 * @param {string} stateKey Reducer state key
 * @param {string} defaultUrl Default fetch URL of table
 * @returns {Function}
 */
export const updateTableOnFilterChange = (stateKey, defaultUrl) =>
    (param, value) =>
        dispatch =>
            dispatch(
                fetchData(stateKey, queryUrl(defaultUrl, { filter: { [param]: value } })),
            );



// WEBPACK FOOTER //
// ./src/js/helpers/dispatchProps.js